export default {
	title: 'Grupo de Modelos de Algoritmo',
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote',
		modelConfig: 'Configuración del Modelo',
		start: 'Iniciar',
		stop: 'Detener'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Eliminación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa',
		setSuccess: 'Configuración exitosa',
		configSuccess: 'Configuración exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		modelConfigNotExist: 'La configuración del modelo no existe'
	},
	form: {
		name: 'Nombre del Grupo de Modelos',
		code: 'Código del Grupo de Modelos',
		faultModelName: 'Nombre del Modelo de Falla',
                sys: 'Seleccionar valores característicos',
		mmcodeList: 'Seleccionar Modelo',
		placeholder: {
			name: 'Por favor ingrese el nombre del grupo de modelos',
			code: 'Por favor ingrese el código del grupo de modelos'
		}
	},
	table: {
		name: 'Nombre del Grupo de Modelos',
		code: 'Código del Grupo de Modelos',
		mmCodeDescList: 'Nombre del Modelo',
		mmcodeList: 'Código del Modelo',
		isEnable: 'Habilitado'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar',
		modelConfigTitle: 'Configuración del Modelo'
	},
	gridLayout: 'Diseño de Cuadrícula',
	columns: {
		deviceName: 'Nombre del Dispositivo',
		sensorName: 'Nombre del Sensor',
		modelGroupName: 'Nombre del Grupo de Modelos',
		modelCode: 'Código del Modelo',
		modelName: 'Nombre del Modelo',
		isEnabled: 'Habilitado',
		action: 'Acción'
	},
	config: {
		selectDevice: 'Seleccionar Dispositivo',
		selectSensor: 'Seleccionar Sensor',
		selectAlgorithmGroup: 'Grupo de Modelos de Algoritmo',
		selectModel: 'Seleccionar Modelo',
		modelType: 'Tipo de Modelo',
		modelCategory: 'Categoría del Modelo',
		modelCategoryCode: 'Código de Categoría del Modelo',
		modelSubcategory: 'Subcategoría del Modelo',
		modelSubcategoryCode: 'Código de Subcategoría del Modelo',
		modelDescription: 'Descripción del Modelo',
		modelVersion: 'Versión del Modelo',
		paramConfig: 'Configuración de Parámetros',
		paramType: 'Tipo de Parámetro',
		paramValue: 'Valor de Parámetro',
		paramDesc: 'Descripción de Parámetro'
	},
	waveConfig: 'Configuración de Onda de Aceleración',
	narrowBandWarning: 'Advertencia de Banda Estrecha',
	narrowBandWarningDesc: 'Detectar posibles fallas en el equipo analizando cambios de energía de banda estrecha y emitir advertencia (ZDYJ)',
	broadBandWarning: 'Advertencia de Banda Ancha',
	broadBandWarningDesc: 'Detectar posibles fallas en el equipo analizando cambios de energía de banda ancha y emitir advertencia (KDYJ)',
	configSuffix: ' Configuración',
	status: {
		enabled: 'Habilitado',
		disabled: 'Deshabilitado'
	}
}
